import { Component, OnInit, OnDestroy} from "@angular/core";
import { Router } from "@angular/router";
//import { GridOptions, AllModules, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";
import { Observable } from "rxjs";

import { IconActionRendererComponent } from "../../../common/components/ag-grid/icon-action-renderer.component";
import { GridFormatterService } from "../../../common/services/grid-formatter.service";
import { DialogService } from '../../../common/services/dialog.service';
import { EventsService } from "../../../services/events.service";
import { GroupService } from "../../services/group.service";
import { SubHeaderService } from "../../../core/services/sub-header.service";

import { Group } from "../../models/group.model";
import { SubHeader } from "../../../core/models/sub-header.model";

@Component({
    selector: "manage-groups",
    templateUrl: "./manage-groups.component.html",
    standalone: false
})
export class ManageGroupsComponent implements OnInit {

	public gridOptions: GridOptions;
	private gridApi?: GridApi;
  public allGroups: Observable<Group[]>;
  public subHeader: SubHeader = new SubHeader({ title: "Manage Groups", buttons: [{ name: "Add New Group", method: () => this.addNewGroup() }] });
  public objectId: any;

  constructor(
    public subHeaderService: SubHeaderService,
    public router: Router,
    public groupService: GroupService,
    public dialogService: DialogService,
	  public eventsService: EventsService,
	private _formatter: GridFormatterService
  ) { }

  ngOnInit() {
    this.subHeaderService.updateSubHeader(this.subHeader);
    this.getGroups();
    this.gridOptions = <GridOptions>{
        columnDefs: this.createColumnDefs(),
        enableBrowserTooltips: false,
        tooltipTrigger: 'focus',
        headerHeight: 50,
		    defaultColDef: { filter: true, resizable: true, sortable: true } as ColDef,
		    onGridReady: (params) => { 
          this.gridApi = params.api; 
          this.gridApi.sizeColumnsToFit();
        },
        onRowDataUpdated: () => {
            if (this.gridApi != null) {
              this.gridApi.sizeColumnsToFit();
            }
        }
    };
    //reset column widths on window resize
    this.eventsService.create('manage-group', window, 'resize', () => {
      if (this.gridApi != null) {
        this.gridApi.sizeColumnsToFit();
      }
    });
  }

  ngOnDestroy() {
    if (this.eventsService)
      this.eventsService.remove('manage-group');
  }

  public getGroups(): void {
    this.allGroups = this.groupService.get({ stubs: false }) as Observable<Group[]>;
  }

  public createColumnDefs(): ColDef[] {
    const columnDefs = [
      {
        headerName: "Group Name",
        headerTooltip: "Group Name",
        field: "displayName",
        tooltipField: "displayName",
        maxWidth: 910
      },
      {
          headerName: "Type",
          headerTooltip: "Type",
          field: "groupType",
          maxWidth: 125,
          minWidth: 100,
          tooltipValueGetter: this.groupTypeFormatter(),
          valueGetter: this.groupTypeFormatter()
      },
      {
          headerName: "Status",
          headerTooltip: "Status",
          field: "active",
          maxWidth: 125,
          minWidth: 100,
          tooltipValueGetter: this.statusFormatter(),
          valueGetter: this.statusFormatter()
      },
      {
        headerName: "",
        field: "",
        maxWidth: 125,
        minWidth: 100,
        filter: false,
        sortable: false,
        cellStyle: { 'text-align': 'center', 'line-height': 1.75 },
        cellRenderer: IconActionRendererComponent,
        cellRendererParams: {
          buttons: [
            {
              action: (obj: any) => this.edit(obj),
              label: 'Edit Group',
              icon: 'edit',
            }, {
              action: (obj: any) => this.delete(obj),
              label: 'Delete Group',
              icon: 'delete'
            }
          ]
        }
      }
    ]
    this._formatter.applyFilterKeyboardHintTooltips(columnDefs);
    return columnDefs;
    }

    public groupTypeFormatter() {
        return (obj: any) => {
            if (!obj.data.groupType) return obj.data.groupType;
            return obj.data.groupType[0].toUpperCase() + obj.data.groupType.slice(1);
        };
    }

    public statusFormatter() {
        return (obj: any) => {
            return obj.data.active === true ? "Active" : "Inactive"
        };
    }

  public addNewGroup(): void {
    this.router.navigate(['admin', 'group']);
  }

  public delete(obj: any): void {
    this.objectId = obj.id;
    this.dialogService.openDialog('confirmCancel', `Are you sure you want to delete ${obj.displayName}`);
  }

  public deleteGroup(): void {
    this.groupService.delete(this.objectId).subscribe(success => {
    this.getGroups();
    });
  }

  public edit(obj: any): void {
    this.router.navigate(['/admin/group/', obj.id])
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    this.deleteGroup();
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}
